/**
 * @ngdoc service
 * @description
 * # MsisdnFormatterService
 * Replace number/text into specific formatted string (ex msisdn)
 */
export function formatMsisdn(msisdnNumber, formatPattern) {
    let msisdn = msisdnNumber.toString();
    let formattedMsisdn;
    if (msisdn.length === 9) {
        msisdn = '0' + msisdn;
    }
    if (formatPattern) {
        formattedMsisdn = msisdn.replace(/(\d{4})(\d{2})(\d{2})(\d{2})/, formatPattern);
    }
    else {
        formattedMsisdn = msisdn.replace(/(\d{4})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4');
    }
    return formattedMsisdn;
}
/**
 * Formats a string to the NA formatInternet.
 * @param {String} NA
 * @returns {String} formatted NA
 */
export function formatNa(na) {
    let formattedNa = na;
    if (na.length === 9) {
        const validTwoDigitsPrefix = /^(02|03|04|09)/;
        if (validTwoDigitsPrefix.test(na)) {
            formattedNa = na.replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4');
        }
        else {
            formattedNa = na.replace(/(\d{3})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4');
        }
    }
    return formattedNa;
}
export function getDisplayNumber(accessNumber) {
    let displayNumber = '';
    if (accessNumber) {
        if (accessNumber.length === 10) {
            displayNumber = formatMsisdn(accessNumber);
        }
        else {
            displayNumber = formatNa(accessNumber);
        }
    }
    return displayNumber;
}
